<template>
  <div class="row">
    <div class="col-xs-12">
      <button
        v-if="nextButton"
        class="btn btn-lg btn-primary mbs"
        :disabled="disabled"
        @click="$emit('next')"
      >
        {{ finalStep ? lang.get('buttons.finish') : lang.get('buttons.next') }}
      </button>
    </div>
    <div class="col-xs-12">
      <button
        v-if="backButton"
        class="btn btn-link pas"
        :disabled="disabled"
        @click="$emit('back')"
      >
        <icon name="arrow-tail-left" />
        {{ lang.get('buttons.back') }}
      </button>
    </div>
  </div>
</template>

<script>
import Icon from '@/lib/components/Shared/Icon';

export default {
  inject: ['lang'],
  components: {
    Icon
  },
  props: {
    backButton: {
      type: Boolean,
      default: true
    },
    nextButton: {
      type: Boolean,
      default: true
    },
    finalStep: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>
